// MetadataSection.styled.ts
import styled from "styled-components";

import { device } from "utils/sizes";
import { colourScheme } from "utils/styling/colours";
import { Span, SubTitle, Text } from "utils/styling/typography.styled";

export const Card = styled.div`
    width: 100%;
    // max-width: 40rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 0 auto;
    background-color: ${colourScheme.primary};
    color: ${colourScheme.fullWhite};
    box-shadow: 0 4px 6px ${colourScheme.shadow};
    border-radius: 0.5rem;
    overflow: hidden;
`;

export const CardHeader = styled.div`
    border-bottom: 1px solid ${colourScheme.primaryLight};
    padding: 1rem;
`;

export const CardTitle = styled(SubTitle)`
    font-size: 1.25rem;
    font-weight: bold;
    color: ${colourScheme.secondaryLight};
    margin: 0;

    ${device.md} {
        font-size: 1.5rem;
    }
`;

export const CardContent = styled.div`
    padding: 1rem;

    ${device.md} {
        padding: 1.5rem;
    }
`;

export const ScrollArea = styled.div`
    justify-content: center;
    align-items: center;
    overflow-y: none;
    padding: 1rem;
`;

export const Section = styled.div`
    margin-bottom: 1rem;

    ${device.md} {
        margin-bottom: 1.5rem;
    }
`;

export const SubSection = styled.div`
    margin-bottom: 1rem;
`;

export const SectionTitle = styled(SubTitle)`
    font-size: 1rem;
    font-weight: 600;
    color: ${colourScheme.secondaryLight};
    margin: 0 0 0.5rem 0;

    ${device.md} {
        font-size: 1.125rem;
    }
`;

export const UserInfoContainer = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;

    gap: 0.75rem;

    ${device.md} {
        gap: 1rem;
    }
`;

export const UserInfoText = styled.div`
    display: flex;
    flex-direction: column;
`;

export const UserCreatedAt = styled(Text)`
    font-size: 0.75rem;
    color: ${colourScheme.greyLight};
    margin: 0;

    ${device.md} {
        font-size: 0.875rem;
    }
`;

export const Separator = styled.hr`
    border: none;
    border-bottom: 1px solid ${colourScheme.primaryLight};
    margin: 1rem 0;

    ${device.md} {
        margin: 1.5rem 0;
    }
`;

export const DetailsGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.5rem;
    font-size: 0.75rem;

    ${device.md} {
        font-size: 0.875rem;
    }
`;

export const DetailItem = styled.div<{ fullWidth?: boolean }>`
    display: flex;
    flex-direction: column;

    ${(props) =>
        props.fullWidth &&
        `
    grid-column: 1 / -1;
  `}
`;

export const DetailLabel = styled(Text)`
    font-size: 0.75rem;
    font-weight: 500;
    color: ${colourScheme.greyLight};
    margin: 0;
`;

export const DetailValue = styled(Text)`
    font-size: inherit;
    margin: 0;
`;

export const Badge = styled(Span)<{ variant: "default" | "secondary" }>`
    display: inline-block;
    padding: 0.25rem 0.5rem;
    font-size: 0.75rem;
    border-radius: 0.25rem;
    background-color: ${({ variant }) =>
        variant === "default"
            ? colourScheme.successLight
            : colourScheme.primary};
    color: ${({ variant }) =>
        variant === "default" ? colourScheme.primaryDark : colourScheme.white};
`;

export const DescriptionText = styled(Text)`
    font-size: 0.75rem;
    margin: 0;

    ${device.md} {
        font-size: 0.875rem;
    }
`;
